export * from '@primeuix/themes/material/knob';
export { default } from '@primeuix/themes/material/knob';
